import { l } from '../../../engine/lodash'
import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { createId } from '../../../main/common'
import { chessPieces } from '../chessPieces-sidecar'
import { EChessPieceType } from '../chessPiecesData'
import { chessTilemap } from '../chessTilemap-sidecar'
import { EChessMessage } from './chessMessageIds'
import { chessMessagePieceCreate } from './chessMessagePieceCreate-sidecar'
import { chessMessagePieceKill } from './chessMessagePieceKill-sidecar'
import { chessMessagePieceMove } from './chessMessagePieceMove-sidecar'
import { chessWebsockets } from './chessWebsockets-sidecar'

export interface IChessMessagePieceMoveRequest {
  pieceId: number
  i: number
  j: number
}

export const messageId = EChessMessage.PieceMoveRequest

export function write(m: IMessageWriter, d: IChessMessagePieceMoveRequest) {
  messageWriter.write8(m, messageId)
  messageWriter.write32(m, d.pieceId)
  messageWriter.write16(m, d.i)
  messageWriter.write16(m, d.j)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, messageId)

  let d: IChessMessagePieceMoveRequest = {
    pieceId: messageWriter.read32(m),
    i: messageWriter.read16(m),
    j: messageWriter.read16(m),
  }

  return d
}

export function test() {
  let ex: IChessMessagePieceMoveRequest = {
    pieceId: 100,
    i: 7,
    j: 8,
  }
  messageWriter.test('piece-move-request', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)
  let cp = chessPieces.findByIdSafe(msg.pieceId)
  let tHere = chessTilemap.getSafeIJ(msg)

  if (chessWebsockets.getIsHost()) {
    if (tHere && cp && !cp.isDead) {
      // Make sure we can move
      let canMove = chessTilemap.canMove(cp, tHere)

      if (canMove) {
        if (tHere.pieces.length > 0) {
          l.forEach(tHere.pieces, (c) => {
            chessMessagePieceKill.sendMessageAndImmediatelyExecute({
              pieceId: c.id,
            })
          })
        }
        chessMessagePieceMove.sendMessageAndImmediatelyExecute({
          pieceId: cp.id,
          i: msg.i,
          j: msg.j,
        })

        if (cp.type === EChessPieceType.Pawn) {
          if (msg.i === 8 - 1 || msg.i === 0) {
            // Convert to queen
            let team = cp.team
            chessMessagePieceKill.sendMessageAndImmediatelyExecute({
              pieceId: cp.id,
            })
            chessMessagePieceCreate.sendMessageAndImmediatelyExecute({
              pieceId: createId(),
              team: team,
              type: EChessPieceType.Queen,
              i: msg.i,
              j: msg.j,
              energy: 0,
            })
          }
        }
      } else {
        console.warn('piece-move-request', 'cannot move piece (probably race)')
      }
    }
  }
}

export function sendMessageRequest(msg: IChessMessagePieceMoveRequest) {
  websockets._sendMessageRequest(write, msg)
}
